// extracted by mini-css-extract-plugin
module.exports = {"mobile":"styles_mobile__2DnAP","tablet":"styles_tablet__OqMtU","desktop":"styles_desktop__1kyEE","TabHeader":"styles_TabHeader__1XpkP","active":"styles_active__86zAq"};